import { render, staticRenderFns } from "./NonOffProducts.vue?vue&type=template&id=2bb5e56c&"
import script from "./NonOffProducts.vue?vue&type=script&lang=js&"
export * from "./NonOffProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports